import {
  computed, inject, Ref, ref
} from 'vue'
import {
  Environment, IUnauthenticatedRealmSettings
} from '@src/types/realmSettings.types'
import { getLogoutUrl } from '@src/utilities/auth'
import { realmSettingsKey } from '@src/realmSettingKey.type'

export default function useRealmSettings() {
  const realmSettings = inject(realmSettingsKey) as Ref<IUnauthenticatedRealmSettings>

  const realmSettingsLoading = ref(false)
  const isWhatsNewEnabled = computed(() => {
    return (
      realmSettings.value.whats_new.enabled
        && realmSettings.value.general.environment !== Environment.ONPREM
    )
  })
  const logoutUrl = computed(() => {
    const settings = realmSettings.value
    const canBuildUrl = !!settings.auth.keycloak_url && !!settings.metadata.realm_id
    return canBuildUrl ? getLogoutUrl(settings) : undefined
  })

  return {
    logoutUrl,
    realmSettings,
    realmSettingsLoading,
    isWhatsNewEnabled
  }
}
